import apiClient from '@/plugins/axios';

export default {
	get(userId, opts = {}) {
		return apiClient.get(`v1/User/${userId}`, { ...opts });
	},

	list(params, opts = {}) {
		return apiClient.get('v1/User', { params, ...opts });
	},

	create(body, opts = {}) {
		return apiClient.post('v1/User', body, opts);
	},

	update(userId, body, opts = {}) {
		return apiClient.put(`v1/User/${userId}`, body, opts);
	},

	updateRoles(userId, body, opts = {}) {
		return apiClient.put(`v1/User/Roles/${userId}`, body, opts);
	},

	delete(userId, opts = {}) {
		return apiClient.delete(`v1/User/${userId}`, opts);
	},

	login(body, opts = {}) {
		return apiClient.post('v1/User/Login', body, opts);
	},

	logout(body, opts = {}) {
		return apiClient.post('v1/User/Logout', body, opts);
	},

	resetPassword(body, opts = {}) {
		return apiClient.post('v1/User/ResetPassword', body, opts);
	},

	getUsers(searchParam) {
		var query = `?PageNumber=${searchParam.currentPage}&PageSize=${searchParam.pageSize}`;
		query += searchParam.search ? `&Search=${searchParam.search}` : '';
		query += searchParam.identityId
			? `&IdentityId=${searchParam.identityId}`
			: '';
		query += searchParam.orderBy ? `&OrderBy=${searchParam.orderBy}` : '';
		query += searchParam.customerId
			? `&CustomerId=${searchParam.customerId}`
			: '';

		return apiClient.get(`v1/User${query}`);
	},

	getUser(userId) {
		return apiClient.get(`v1/User/${userId}`);
	},

	createUser(user) {
		return apiClient.post('v1/User', user);
	},

	updateUser(user) {
		var userId = user.id;

		return apiClient.put(`v1/User/${userId}`, user);
	},

	deleteUser(userId) {
		return apiClient.delete(`v1/User/${userId}`);
	},

	getLoggedInUser(identityId) {
		return apiClient.get(`v1/User/login/${identityId}`);
	},

	changePassword(body, opts = {}) {
		return apiClient.post('v1/User/ChangePassword', body, opts);
	},

	linkCustomer(body, opts = {}) {
		return apiClient.post('v1/User/LinkCustomer', body, opts);
	},

	unlinkCustomer(userId, customerId, body, opts = {}) {
		return apiClient.put(`v1/User/DeleteUser/${userId}/FromCustomer/${customerId}`, body, opts);
	},

	getUsersIncludingExternal(params, opts = {}) {
		return apiClient.get('v1/User/GetUsersIncludingExternal', { params, ...opts });
	},

	getAvailableRolesForUser(opts = {}) {
		return apiClient.get('v1/IdentityRole', opts);
	}
};
